import cn from "classnames";
import { ColorProps, ElementType } from "../types";

export const useColorProps = <T extends ColorProps>(
  props: T,
  el: ElementType
) => {
  // Remove color from props list to prevent passing down.
  const { color, ...rest } = props;

  // Create the new className with color classes added to existing class names.
  const className: string = cn(
    `${el}-${color ? color : "primary"}`,
    props.className
  );

  // Update the className value of rest to return.
  const output = { ...rest, className };

  // return the updated props;
  return output;
};
